import { render, staticRenderFns } from "./AuthorLogin.vue?vue&type=template&id=0ff7e62c&scoped=true"
import script from "./AuthorLogin.vue?vue&type=script&lang=js"
export * from "./AuthorLogin.vue?vue&type=script&lang=js"
import style0 from "./AuthorLogin.vue?vue&type=style&index=0&id=0ff7e62c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff7e62c",
  null
  
)

export default component.exports